import { createStore } from '../_core/createStore';
import { progressStore } from './progressStore';

const useProgressStore = createStore({
  creator: progressStore,
  id: 'progress',
  middlewares: {
    devtools: true,
  },
});

export default useProgressStore;
